export default __webpack_public_path__ + "static/media/Press Release - Q3 FY 25.865d5c8e.pdf";